import { render, staticRenderFns } from "./ConfirmationDialogApproveOrder.vue?vue&type=template&id=19db9dab"
import script from "./ConfirmationDialogApproveOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogApproveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports